import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EmptyPlaceholderModule } from '@epicuro-next/ataraxia/empty-placeholder';
import { FullScreenModule } from '@epicuro-next/ataraxia/fullscreen';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { InfiniteScrollModule } from '@epicuro-next/ataraxia/infinite-scroll';
import { MediaPreviewModule } from '@epicuro-next/ataraxia/media-preview';
import { AtaraxiaPaginationLoaderModule } from '@epicuro-next/ataraxia/pagination-loader';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { PRODUCT_LIST_NAMESPACE } from '@epicuro-next/constants/rule-engine/product-list-rules';
import { EpicShowPlayerModule } from '@epicuro-next/features/lists/epic-show-player';
import { ListsModule } from '@epicuro-next/features/lists/lists-common';
import { ProductsSearchListModule } from '@epicuro-next/features/products-search-list';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { EnvironmentModule } from '@epicuro-next/platform/environment';
import { ProductCardModule } from '@epicuro-next/product-card';
import { ListProductReferenceEntitiesModule } from '@epicuro-next/state/list-product-reference-entities';
import { PBasketStateModule } from '@epicuro-next/state/p-basket-state';
import { ProductListStoreModule } from '@epicuro-next/state/product-list-state';

import { ConsumerEpicShowComponent } from './components/consumer-epic-show/consumer-epic-show.component';
import { ListProductsComponent } from './components/list-products/list-products.component';
import { NoProductsComponent } from './components/no-products/no-products.component';
import { ListProductsContainerComponent } from './containers/list-products-container/list-products-container.component';

@NgModule({
  declarations: [
    ListProductsContainerComponent,
    ListProductsComponent,
    NoProductsComponent,
    ConsumerEpicShowComponent,
  ],
  imports: [
    CommonModule,
    ProductListStoreModule,
    IconsModule,
    PBasketStateModule,
    ProductsSearchListModule,
    RouterModule,
    AtaraxiaPaginationLoaderModule,
    MediaPreviewModule,
    FullScreenModule,
    ListsModule,
    EmptyPlaceholderModule,
    EpicShowPlayerModule,
    InfiniteScrollModule,
    ConfigurationModule.forFeature(PRODUCT_LIST_NAMESPACE),
    ProductCardModule,
    TooltipDirective,
    ListProductReferenceEntitiesModule,
    EnvironmentModule,
  ],
  exports: [
    ListProductsContainerComponent,
    ListProductsComponent,
    NoProductsComponent,
  ],
})
export class ListContentModule {}
